import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function ServiceProcess() {
  const steps = [{
    number: '01',
    title: 'Diagnose',
    description: "A quick assessment shows where your team actually stands. Who's effective with AI, who's struggling, and what's getting in the way."
  }, {
    number: '02',
    title: 'Build',
    description: "A multi-week program built around your team's real work. Not slides and theory. Hands-on skills your team applies between sessions and brings back with real questions."
  }, {
    number: '03',
    title: 'Sustain',
    description: 'Your strongest adopters become AI champions who keep the momentum going, maintain a shared toolkit, and help the team keep up as AI evolves. The result compounds long after the engagement ends.'
  }];
  return <section className="w-full bg-brand-warm-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-304" data-mp="23p9o41qal30x">
      <div className="max-w-7xl mx-auto" data-id="element-305" data-mp="28o2wjfqq23u8">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10" data-id="element-306" data-mp="18lmzurtcvkjb">
          How the program works
        </h2>

        <ol className="flex flex-col md:flex-row md:items-start gap-8 md:gap-0" data-id="element-307" data-mp="13lieoohi61mr">
          {steps.map((step, index) => <React.Fragment key={step.title} data-id="element-308" data-mp="yp9w1143jqau" data-mpi={index}>
              <li className="flex-1 md:px-6 md:first:pl-0 md:last:pr-0" data-id="element-309" data-mp="umdjns55gqfc">
                <div className="flex items-baseline gap-3 mb-3" data-id="element-310" data-mp="1rbuwcr2jvcqj">
                  <span className="text-brand-orange font-heading font-bold text-sm" data-id="element-311" data-mp="1rb31jigs1j1b">
                    {step.number}
                  </span>
                  <h3 className="text-xl font-bold text-brand-navy" data-id="element-312" data-mp="1hlt73vygnoa1">
                    {step.title}
                  </h3>
                </div>
                <p className="text-brand-gray leading-relaxed" data-id="element-313" data-mp="1djy7qx03bkyw">
                  {step.description}
                </p>
              </li>
              {index < steps.length - 1 && <li aria-hidden="true" className="hidden md:flex items-center pt-1 text-brand-orange" data-id="element-314" data-mp="25aub9709gd9i">
                  <ArrowRightIcon className="w-5 h-5" data-id="element-315" data-mp="8cx1yc0cop3b" />
                </li>}
            </React.Fragment>)}
        </ol>
      </div>
    </section>;
}